import styled from 'styled-components';

import Avatar from '@/components/Avatar/Avatar';
import Button from '@/components/Button/Button';
import Typo from '@/components/Typography/Typo';
import useAppLogout from '@/hooks/domain/App/use-app-logout';
import useColor from '@/hooks/domain/useColor';
import useUserStore from '@/stores/UserStore';

import { Flex } from '../../../components/base';
import SettingHeader from '../Header';

const MyAccountSettingBody = () => {
  const color = useColor();
  const { user } = useUserStore((state) => ({ user: state.user }));
  const logout = useAppLogout();

  return (
    <>
      <SettingHeader title="My Account" />
      <Wrapper a="center" d="row" g="32px">
        <Avatar
          character={user?.firstName[0] || '?'}
          size={72}
          color={color.profile[user?.color || 0]}
          fontSize="40px"
        />
        <Flex d="column" g="8px">
          <Typo weight="sb" color={color.gray800}>
            {user?.firstName + ' ' + user?.lastName}
          </Typo>
          <Typo type="body2" weight="r" color={color.gray800}>
            {user?.email}
          </Typo>
        </Flex>
      </Wrapper>

      <Flex padding="0px 32px" style={{ width: 200 }}>
        <Button
          onClick={logout}
          variant="error_outlined"
          sizeType="m"
          style={{ width: '100%' }}
        >
          Logout
        </Button>
      </Flex>
    </>
  );
};

export default MyAccountSettingBody;

const Wrapper = styled(Flex)`
  width: 100%;
  padding: 32px;
`;
